import React, { useEffect } from "react";
import "./PricingTable.css";
import Globe from "../assets/globe.jpeg";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function PricingTable() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <>
      <Navbar />


      {/* HERO */}
      <section
        className="pricing-hero"
        style={{
          backgroundImage: ` url(${Globe})`,
        }}
      >
        <div className="pricing-hero-content">
          <h1>Choose the Perfect Plan</h1>
          <p>
            Flexible pricing solutions designed to support your business growth.
          </p>
        </div>
      </section>





      {/* PRICING TABLE */}
      <section className="pricing-section">
        <h2>Our Best Pricing</h2>
       

       <div className="pricing-table-wrapper">
        <table className="pricing-table">
          <thead>
            <tr>
              <th></th>
              <th>BEGINNER</th>
              <th>PROFESSIONAL</th>
              <th>PREMIUM</th>
            </tr>
            <tr className="price-row">
              <th>Plan</th>
              <th>Rs. 9999/-</th>
              <th>Rs. 15k - 20k</th>
              <th>Rs. 45k+</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Professional online presence for your business</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
            </tr>

            <tr>
              <td>Works perfectly on mobile, tablet, and desktop</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
            </tr>

            <tr>
              <td>Fast loading website</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
            </tr>

            <tr>
              <td>Basic contact form for customer enquiries</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
            </tr>

            <tr>
              <td>Social media links integration</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
            </tr>

            <tr>
              <td>Admin panel to manage website data easily</td>
              <td className="cross">X</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
            </tr>

            <tr>
              <td>Customer enquiry data saved automatically</td>
              <td className="cross">X</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
            </tr>


            <tr>
              <td>Better control over business information</td>
              <td className="cross">X</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
            </tr>

            <tr>
              <td>Business reports and performance insights</td>
              <td className="cross">X</td>
              <td className="tick">✓</td>
              <td className="tick">✓</td>
            </tr>

            <tr>
              <td>High security for customer data</td>
              <td className="cross">X</td>
              <td className="cross">X</td>
              <td className="tick">✓</td>
            </tr>

            <tr>
              <td>Email Service</td>
              <td className="cross">X</td>
              <td className="cross">X</td>
              <td className="tick">✓</td>
            </tr>

            <tr>
              <td>Google Reviews & Footprinting</td>
              <td className="cross">X</td>
              <td className="cross">X</td>
              <td className="tick">✓</td>
            </tr>
          </tbody>
        </table>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default PricingTable;